export const useDatosPrevision = () => {
  let errObj = {};

  const validatePrevision = obj => {
    const { jubilado, previsionSalud, previsionSocial, planPactado } = obj;

    if (!jubilado) { errObj.jubilado = "Requerido"; }
    if (!previsionSalud) { errObj.previsionSalud = "Requerido"; }
    if (!previsionSocial) { errObj.previsionSocial = "Requerido"; }
    if (`${previsionSalud}` !== "1" && !planPactado) { errObj.planPactado = "Requerido"; }
    if (`${previsionSalud}` !== "1" && (planPactado === '0' || planPactado === '0,')) {
      errObj.planPactado = "Ingrese corretamente el valor de la UF";
    }
    return errObj;
  }

  return { validatePrevision }
}